/**
 * #2005 — the DISPLAY-side defence for a job's free text.
 *
 * `jobs.employer_requests` and `jobs.comment` are written by whoever can edit a job — a
 * Client Admin, an employer user, a steward — and rendered with `v-html` in eleven places:
 * the schedule modal (two of them), the calendar event panel, addCall, the job detail pages
 * and the employer job detail page. Nothing validated either column on save and nothing
 * sanitised either on display, so a `<script>` or an `onerror=` typed into an employer
 * request was stored verbatim and executed in the browser of every dispatcher who opened
 * that job. `contentRules.js` says this plainly already: *"It is a typo-and-paste guard, NOT
 * an XSS defence … Nothing in this module should be read as protecting a `v-html` sink."*
 *
 * ══ WHY THE DISPLAY PATH AND NOT ONLY THE SAVE PATH ══
 *
 * Every row written before this MR is unvalidated, so a save-time rule protects nobody who
 * opens an existing job. Sanitising where it is rendered disarms the rows that are already
 * there — the same reasoning, and the same `sanitize()`, that #2036 used for the login
 * message and #2041 for the privacy policy (`privacyPolicyReview.vue`).
 *
 * ══ WHICH ALLOW-LIST ══
 *
 * The DEFAULT profile (`loginMessage`), deliberately: it is the narrowest, it is the one
 * pinned to the server's `SafeHtml::ALLOWED_TAGS` by `tests/Unit/SafeHtmlTest.php`, and
 * `profileOf()` already falls back to it so a typo tightens the rules rather than loosening
 * them. Adding a `jobText` profile would mean adding it to BOTH lists and to the agreement
 * test for no gain — bold, italic, underline, lists and links are what a job note needs.
 *
 * ⚠ CONSEQUENCE WORTH LOOKING AT ON stage-: content pasted from Word with TABLES or HEADINGS
 * renders as plain text instead of a table, because neither is on the allow-list. The text
 * survives (DOMPurify keeps element content); the layout does not. If ed wants tables in an
 * employer request, that widens the profile on BOTH sides — it is not something to decide
 * inside a validation fix.
 */
import { sanitize } from './safeHtmlRules.js';

export default {
  methods: {
    /**
     * Render-time sanitise for a job's free text. Null/undefined becomes '' so `v-html`
     * does not print "undefined".
     */
    safeJobText(value) {
      return sanitize(value);
    },
  },
};
